var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Registry } from './Registry';
import { memoize } from '../utils/mobx/decorators/memoize';
import { runtime } from '../classes/runtime/Runtime';
import { flatten } from '../utils/helper/lodash_replacements';
export class RegistryCategory {
    parent;
    isRoof = false;
    constructor(parent) {
        this.parent = parent;
    }
    label = '(leer)';
    init() {
        for (const key of this.ownKeys) {
            this.registryRoof.rawRegistryItems[key] = this[key];
        }
    }
    get ownKeys() {
        return Object.keys(this).filter(key => !['constructor', 'label', 'parent', 'isRoof', '_memoized_registryCategoryEdit', 'cssKeys'].includes(key));
    }
    get categoryKeys() {
        return this.ownKeys.filter(key => key.startsWith('c_'));
    }
    get categories() {
        return this.categoryKeys.map(key => this[key]).filter(c => c);
    }
    get allCategories() {
        return this.categories.concat(...this.categories.map(category => category.allCategories));
    }
    get leafKeys() {
        return this.ownKeys.filter(key => !key.startsWith('c_'));
    }
    get allLeafKeys() {
        return flatten(this.allCategories.map(category => category.leafKeys));
    }
    get leafs() {
        if (this.isRoof)
            return [];
        return this.leafKeys.map(key => this.registryRoof.registry_object[key]).filter(l => !!l);
    }
    get allLeafs() {
        return this.leafs.concat(...this.categories.map(category => category.allLeafs));
    }
    get registryCategoryEdit() {
        return new runtime.solidPackages.Edit.classes.RegistryCategoryEdit(this);
    }
    get registry() {
        return this.parent instanceof Registry ? this.parent : this.parent.registry;
    }
    get registryRoof() {
        return this.isRoof ? this : this.parent.registryRoof;
    }
}
__decorate([
    memoize
], RegistryCategory.prototype, "ownKeys", null);
__decorate([
    memoize
], RegistryCategory.prototype, "registryCategoryEdit", null);
